import React from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';

import useIsDesktopLayout from '@hooks/useIsDesktopLayout';

import FixedFooter from './FixedFooter';

const Container = styled(FixedFooter)`
  background-color: ${({ theme }) => theme.commons.footer.background};
  padding: ${({ theme }) => theme.spacing(10, 12)};
  width: 100%;
  position: ${({ isDesktop }) => (isDesktop ? 'initial' : 'fixed')};
  bottom: 0;
  z-index: ${({ theme }) => theme.commons.footer.zIndex};
  box-sizing: border-box;
  border-top-right-radius: ${({ rounded }) => (rounded ? '40px' : 0)};
  border-top-left-radius: ${({ rounded }) => (rounded ? '40px' : 0)};
  box-shadow: ${({ theme, hideBorderTop }) =>
    hideBorderTop ? 'none' : theme.commons.footer.elevation};
`;

export function ShellFooter({ children, className, hideBorderTop, rounded }) {
  const isDesktop = useIsDesktopLayout();
  if (!children) return null;

  const T = typeof children === 'function' ? children() : children;
  if (!T) return null;

  return (
    <Container
      className={className}
      isDesktop={isDesktop}
      hideBorderTop={hideBorderTop}
      rounded={rounded}
    >
      {T}
    </Container>
  );
}

ShellFooter.propTypes = {
  children: PropTypes.oneOfType([
    PropTypes.func,
    PropTypes.node,
    PropTypes.object,
  ]),
  className: PropTypes.string,
  hideBorderTop: PropTypes.bool,
  rounded: PropTypes.bool,
};

ShellFooter.defaultProps = {
  hideBorderTop: false,
  rounded: false,
};
// Do not export as styled component, will break Shell/Main.js logic.
export default ShellFooter;
